import { HelpSection } from 'legacy/lut/components/widgets/public/partner360/helpButton/enums/HelpSection'

export const printing3d = {
  [HelpSection.ProgramOfferings]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1588/aid/4222',
  [HelpSection.Completeness]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4691',
  [HelpSection.BasicInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4697',
  [HelpSection.ContactInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4698',
  [HelpSection.HpContact]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4701',
  [HelpSection.TranslationFactors]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4702',
  [HelpSection.MarketInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4703',
  [HelpSection.FinancialAndSOB]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4704',
  [HelpSection.TopDeal]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4705',
  [HelpSection.LongTerm]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4706',
  [HelpSection.KeyInitiatives]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4816',
  [HelpSection.Bridges]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4708',
  [HelpSection.MDFPlanning]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4709',
  [HelpSection.Graphs]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4710',
  [HelpSection.PBMAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4829',
  [HelpSection.ManagerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4830',
  [HelpSection.PartnerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4831',
  [HelpSection.HistoryAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1652/aid/4832',
}
